const funcs = {
    debounce(func, delay) {
        if (this.timer) clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            func();
        }, delay || 300);
    },

    deepCopy(obj) {
        var result = Array.isArray(obj) ? [] : {};
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (typeof obj[key] === 'object') {
                    result[key] = this.deepCopy(obj[key]); //递归复制
                } else {
                    result[key] = obj[key];
                }
            }
        }
        return result;
    }
};

export default funcs;



// WEBPACK FOOTER //
// ./src/assets/js/utils.js